import { useState } from "react";
import { Mail } from "lucide-react";
import { C } from '../constants';

export default function LoginModal({ onClose, onLogin }) {
  const [email, setEmail] = useState("");
  const [sent,  setSent]  = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const send = async () => {
    if (!email.includes("@")) { setErr("Enter a valid email"); return; }
    setLoading(true); setErr("");
    try {
      const r = await fetch("/api/auth", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ email }) });
      if (r.ok) setSent(true); else setErr("Couldn't send link — try again");
    } catch { setErr("Network error — try again"); }
    setLoading(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.85)", zIndex:999, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:"#0F0F0F", border:"1px solid rgba(201,168,76,0.3)", borderRadius:20, padding:"32px 28px", maxWidth:400, width:"100%", position:"relative", boxShadow:"0 0 60px rgba(201,168,76,0.08)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ height:3, background:"linear-gradient(90deg,#5a3d0e,#e8c875,#ffe87a,#e8c875,#5a3d0e)", backgroundSize:"200% auto", animation:"hmaShimmer 4s linear infinite", borderRadius:"16px 16px 0 0", position:"absolute", top:0, left:0, right:0 }}/>
        <button onClick={onClose} style={{ position:"absolute", top:14, right:16, background:"none", border:"none", color:C.hint, fontSize:20, cursor:"pointer", lineHeight:1 }}>✕</button>
        {!sent ? (<>
          <div style={{ fontSize:10, fontWeight:900, textTransform:"uppercase", letterSpacing:".2em", color:C.gold2, marginBottom:8 }}>◆ Korvus</div>
          <div style={{ fontSize:22, fontWeight:900, color:C.text, marginBottom:6 }}>Sign In</div>
          <div style={{ fontSize:13, color:C.hint, marginBottom:24, lineHeight:1.6 }}>Enter your email — we'll send a magic login link. No password needed.</div>
          <input
            type="email" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()}
            placeholder="your@email.com"
            style={{ width:"100%", padding:"12px 14px", background:"#1a1a1a", border:"1px solid rgba(201,168,76,0.25)", borderRadius:10, color:C.text, fontSize:15, outline:"none", marginBottom:12, fontFamily:"inherit" }}
          />
          {err && <div style={{ fontSize:12, color:C.neg, marginBottom:10 }}>{err}</div>}
          <button onClick={send} disabled={loading}
            style={{ width:"100%", padding:"13px", background:"linear-gradient(135deg,#e8c875,#ffe87a)", color:"#000", border:"none", borderRadius:10, fontSize:14, fontWeight:900, cursor:"pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Sending..." : "Send Magic Link →"}
          </button>
          <div style={{ fontSize:11, color:C.hint, marginTop:16, textAlign:"center" }}>Earn points, unlock ranks, and track your market instincts.</div>
        </>) : (<>
          <div style={{ textAlign:"center", padding:"12px 0" }}>
            <div style={{ marginBottom:12, display:"flex", justifyContent:"center" }}><Mail size={40} strokeWidth={1.5} color="#e8c875"/></div>
            <div style={{ fontSize:20, fontWeight:900, color:C.text, marginBottom:8 }}>Check your inbox</div>
            <div style={{ fontSize:13, color:C.hint, lineHeight:1.6 }}>We sent a magic link to <strong style={{ color:C.text }}>{email}</strong>. Click it to sign in.</div>
            <div style={{ fontSize:11, color:C.hint, marginTop:12 }}>Link expires in 15 minutes.</div>
          </div>
        </>)}
      </div>
    </div>
  );
}
